export enum PushbarImageType {
  active = 'ACTIVE',
  failed = 'FAILED',
  inactive = 'INACTIVE',
  success = 'SUCCESS',
}
